import { useMemo } from 'react';
import { CostsComponent } from '@umd-dit/cost-component-react';
import '@umd-dit/cost-component-react/style.css';
import { createAPI } from '@umd-dit/oidc-core';
import { useAuth } from '@/context/AuthContext';
import { SERVICE_TYPE_CONFIGS } from '@/types/services';

export default function Costs() {
  const { selectedOrganizationId, selectedWorkspaceId, isAdmin } = useAuth();

  console.log('[Costs] Component rendering with:', {
    selectedOrganizationId,
    selectedWorkspaceId,
    isAdmin
  });

  // Create the costs API instance using the centralized API manager
  const costsApi = useMemo(() => {
    const apiUrl = import.meta.env.VITE_COSTS_API_URL;
    if (!apiUrl) {
      console.error('VITE_COSTS_API_URL not configured');
      return null;
    }
    
    console.log('[Costs] Creating API instance with centralized manager');
    return createAPI('costs', apiUrl);
  }, []);

  // Don't render the costs component until we have a workspace selected and API is ready
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center py-8">
          <p className="text-gray-600">Please select a workspace to view costs.</p>
        </div>
      </div>
    );
  }

  if (!costsApi) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center py-8">
          <p className="text-red-600">Failed to initialize costs API. Please check configuration.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-4">      
      {/* React component using centralized API management */}
      <CostsComponent
        app_id="legislative-review"
        apiInstance={costsApi}
        organization_id={selectedOrganizationId}
        workspace_id={selectedWorkspaceId}
        defaultCostView="workspace"
        isAdmin={isAdmin}
        serviceTypeConfigs={SERVICE_TYPE_CONFIGS}
      />
    </div>
  );
}